var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:"$route.path"}),_c('back-to-top',{attrs:{"bottom":"5px","right":"0","visibleoffset":"200"}},[_c('i',{staticClass:"fa fa-chevron-up"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }